export enum LazoCompanyAccountType {
  COMPANY = "COMPANY",
  INDIVIDUAL = "INDIVIDUAL",
}
